<template>
    <div>
        <h3 class="h6 block-title ps-0 fs-6 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z"
                    fill="#F5C1AB"
                />
                <path
                    opacity="0.5"
                    d="M20 17.5C20 19.985 20 22 12 22C4 22 4 19.985 4 17.5C4 15.015 7.582 13 12 13C16.418 13 20 15.015 20 17.5Z"
                    fill="#F5C1AB"
                />
            </svg>
            Participant(s)
        </h3>

        <table v-if="contributors && contributors.length > 0" class="table table-hover mb-0" style="width: 100%">
            <thead>
                <tr>
                    <th class="block-title">{{ $t('checkout.contributor.last_name') }}</th>
                    <th class="block-title">{{ $t('checkout.contributor.first_name') }}</th>
                    <th class="block-title">{{ $t('checkout.contributor.email') }}</th>
                    <th class="block-title">{{ $t('checkout.contributor.price') }}</th>
                    <th class="block-title">{{ $t('checkout.contributor.status') }}</th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="contributor in contributors"
                    :key="contributor.id"
                    v-if="contributor.first_name != 'price_to_pay_for_participation'"
                >
                    <td>{{ contributor.first_name }}</td>
                    <td>{{ contributor.last_name }}</td>
                    <td>{{ contributor.email }}</td>
                    <td>{{ contributor.price | formatPrice($symbolCurrency) }}</td>
                    <td>
                        <span
                            class="btn btn-sm btn-success rounded-pill"
                            v-if="contributor.paid && contributor.price == contributor.paid"
                            >{{ $t('checkout.contributor.paid') }}</span
                        >
                        <span v-else class="btn btn-sm btn-danger rounded-pill">{{ $t('checkout.contributor.not_paid') }}</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="mb-3 row" v-if="contributors && contributors.length > 0"></div>
        <div v-else>
            <div class="alert alert-warning" role="alert">
                <p class="mb-0">{{ $t('checkout.contributor.no_participants') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['contributors', 'currentTotal'],
    data: () => ({
        //
    }),
    mounted() {
        //
    },
    filters: {
        formatPrice(value, currency) {
            if (!value) return ''
            const formattedPrice = value.toFixed(2)
            return `${formattedPrice} ${currency} `
        },
    },
}
</script>

<style scoped>
.block-title {
    font-size: 1rem !important;
}
</style>
